<template>
  <v-container fluid class="pa-0">
    <v-btn
      fixed
      left
      fab
      small
      class="mt-3"
      @click="showStatisticsDialog = true"
      v-if="showStatisticsBtn"
    >
      <v-icon>mdi-chart-bar</v-icon>
    </v-btn>

    <v-dialog v-model="showStatisticsDialog" persistent max-width="700">
      <v-card>
        <v-btn
          absolute
          right
          text
          small
          style="right: 0; z-index: 999;"
          @click="showStatisticsDialog = false"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-card-title class="dialog-title justify-center"
          >Лелеки 2020 - конкурс з обліку гнізд білого лелеки в Україні
        </v-card-title>
        <v-card-text
          >Статистика нанесених гнізд в період проведення конкурсу з 25.05.2020
          по 21.06.2020

          <v-data-table
            :items="statistics"
            :headers="headers"
            :options="optionsStatistics"
            hide-default-footer
            disable-pagination
            disable-filtering
            fixed-header
            height="300"
          >
            <template v-slot:item.name="{ item }">
              <span
                v-html="
                  `<a class='links' target='_blank' href='https://osm.org/user/${item.user}'>${item.user}</a>`
                "
              ></span>
            </template>
          </v-data-table>

          <p><b>Загальна кількість:</b> {{ totalCount }}</p>

          <p>
            Cторінка на сайті OpenStreetMap Wiki -
            <a
              href="https://wiki.openstreetmap.org/wiki/Uk:%D0%9B%D0%B5%D0%BB%D0%B5%D0%BA%D0%B8_2020"
              >link</a
            >, на форумі OpenStreetMap -
            <a href="https://forum.openstreetmap.org/viewtopic.php?pid=788808"
              >link</a
            >
          </p>

          <p>
            Telegram-чат -
            <a href="https://t.me/leleky2020">https://t.me/leleky2020</a>
          </p>

          <div style="display: flex; justify-content: center;">
            <a href="https://www.mapillary.com/" target="_blank">
              <img src="./../assets/mapillary_logo.png" alt="Mapillary" />
            </a>
            <a href="https://openstreetmap.org.ua/" target="_blank">
              <img src="./../assets/osm_logo.png" alt="OpenStreetMap" />
            </a>
            &nbsp;&nbsp;
            <a href="https://scgis.org.ua/" target="_blank">
              <img src="./../assets/scgis_logo.png" alt="Conservation GIS" />
            </a>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <div id="map"></div>

    <v-overlay :value="layerLoader">
      <v-progress-circular indeterminate size="75"></v-progress-circular>
    </v-overlay>
  </v-container>
</template>

<script>
import axios from "axios";
import mapboxgl from "mapbox-gl";

export default {
  name: "MainMap",

  metaInfo: {
    title: process.env.VUE_APP_TITLE,
  },

  data() {
    return {
      mly: {},

      storkMarkersData: {
        type: "FeatureCollection",
        features: [],
      },

      showStatisticsDialog: false,
      showStatisticsBtn: false,

      headers: [
        { text: "Учасник", value: "name", sortable: false },
        { text: "Кількість гнізд", value: "count" },
      ],
      optionsStatistics: {
        sortBy: ["count"],
        sortDesc: ["count"],
      },
      statistics: [],
      totalCount: 0,

      layerLoader: false,
    };
  },

  mounted() {
    this.$gtag.pageview({
      page_path: "/",
    });

    mapboxgl.accessToken = process.env.VUE_APP_MAPBOX_ACCESS_TOKEN;
    const map = new mapboxgl.Map({
      container: "map",
      style: "mapbox://styles/spatialhast/ckarttc4o9z3g1io18wt2k4y8",
      center: [31.198, 48.642],
      zoom: 6.0,
      hash: true,
    });

    map.addControl(new mapboxgl.ScaleControl(), "bottom-left");
    map.addControl(new mapboxgl.NavigationControl(), "bottom-right");

    map.addControl(
      new mapboxgl.GeolocateControl({
        positionOptions: {
          enableHighAccuracy: true,
        },
        trackUserLocation: true,
        showAccuracyCircle: false,
      }),
      "bottom-right"
    );

    map.on("load", () => {
      // map.getStyle().layers.forEach((layer) => {
      //   if (layer.id.indexOf("-label") > 0) {
      //     map.setLayoutProperty(layer.id, "text-field", ["get", "name_ru"]);
      //   }
      // });

      this.layerLoader = true;
      this.getStorkMapData().then(() => {
        this.layerLoader = false;

        map.loadImage("favicon.png", (error, image) => {
          if (error) throw error;
          map.addImage("stork-image", image);

          map.addSource("stork_point", {
            type: "geojson",
            data: this.storkMarkersData,
          });

          map.addLayer({
            id: "stork_point",
            type: "symbol",
            source: "stork_point",
            layout: {
              "icon-image": "stork-image",
              "icon-size": 1,
              "icon-allow-overlap": true,
            },
          });

          this.showStatisticsDialog = true;
          this.showStatisticsBtn = true;
        });

        let popup = new mapboxgl.Popup({
          closeButton: true,
          closeOnClick: true,
        });

        map.on("click", "stork_point", (e) => {
          let coordinates = e.features[0].geometry.coordinates.slice();

          while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
            coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
          }

          let properties = e.features[0].properties;

          let user = `<b>Додав </b><a target="_blank" href="https://www.openstreetmap.org/user/${properties.user}">${properties.user}</a>`;
          let osm_edit = `<a target="_blank" href="https://www.openstreetmap.org/edit?editor=id&node=${properties.id}">Редагувати в iD</a>`;
          let updated = `<b>Оновлено: </b>${properties.timestamp
            .replace("T", " ")
            .replace("Z", "")}`;

          let table_content = "";
          for (let key in properties) {
            if (!["id", "user", "uid", "timestamp"].includes(key)) {
              let value = properties[key];

              if (key === "mapillary") {
                let url = `https://www.mapillary.com/map/im/${value.slice(
                  0,
                  25
                )}`;
                if (value.includes("mapillary.com")) {
                  url = value;
                }

                value = `<a target="_blank" href="${url}">${value.slice(
                  0,
                  25
                )}</a>`;
              }

              if (key === "image") {
                value = `<a target="_blank" href="${value}">${value.slice(
                  0,
                  25
                )}</a>`;
              }

              let row = `<tr><td><b>${key}</b></td><td>${value}</td></tr>`;
              table_content = table_content + row;
            }
          }

          let popup_content = `${user}<br>${updated}<hr><table>${table_content}</table><hr>${osm_edit}`;
          popup.setLngLat(coordinates).setHTML(popup_content).addTo(map);
        });

        map.on("mouseenter", "stork_point", function (e) {
          map.getCanvas().style.cursor = "pointer";

          let coordinates = e.features[0].geometry.coordinates.slice();

          while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
            coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
          }
        });

        map.on("mouseleave", "stork_point", function () {
          map.getCanvas().style.cursor = "";
        });

        // map.addSource("photo_point_circle", {
        //   type: "geojson",
        //   data: this.storkMarkersData,
        // });

        // map.addLayer({
        //   id: "photo_point_circle",
        //   type: "circle",
        //   source: "photo_point_circle",
        //   layout: {},
        //   paint: {
        //     "circle-radius": 5,
        //     "circle-color": "#f00",
        //     "circle-stroke-color": "hsl(0, 0%, 98%)",
        //   },
        // });
      });
    });
  },

  methods: {
    async getStorkMapData() {
      let overpassURL =
        "https://overpass-api.de/api/interpreter?data=[out:json];" +
        encodeURIComponent(
          'area["boundary"="administrative"]["name:uk"="Україна"]->.a;node(area.a)[birds_nest=stork](newer:"2020-01-01T00:00:00Z");out meta;'
        );

      await axios({
        method: "get",
        url: overpassURL,
      })
        .then(
          (response) => {
            let elements = response.data.elements;

            let statistics = {};

            for (const point in elements) {
              let marker = elements[point];
              let id = marker.id;
              let uid = marker.uid;
              let tags = marker.tags;
              let user = marker.user;
              let timestamp = marker.timestamp;

              statistics[user] = (statistics[user] || 0) + 1;
              this.totalCount = (this.totalCount || 0) + 1;

              let properties = {
                id: id,
                uid: uid,
                user: user,
                timestamp: timestamp,
              };

              for (let key in tags) {
                properties[key] = tags[key];
              }

              this.storkMarkersData.features.push({
                type: "Feature",
                properties: properties,
                geometry: {
                  type: "Point",
                  coordinates: [marker.lon, marker.lat],
                },
              });
            }

            for (let user in statistics) {
              let count = statistics[user];
              this.statistics.push({
                user: user,
                count: count,
              });
            }
          },
          (error) => {
            console.log("error", error);
            throw error;
          }
        )
        .catch((error) => {
          console.log("cerror", error);
          throw error;
        });
    },
  },
};
</script>
